export default __webpack_public_path__ + "static/media/chart.69fc9140.svg";